import { useMainPageContext } from "@/contexts/MainPageContext";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect, useMemo } from "react";
import { StyledMenuItemContent } from "./general-promotion-select-styled";
import { formatCurrency } from "@/helper/common";
import { calculatePromotionLimits, doesPromotionApply, getDecoupledItems, getPromotionName } from "@/helper/promotions";
import { parseAmount } from "@/helper/parseAmount";

export function GeneralPromotionSelect() {
    const { promotions, choosenGeneralPromotion, setChoosenGeneralPromotion, selectedProducts } = useMainPageContext();
    const availablePromotions = useMemo(() => {
        return promotions.filter((promotion) => !promotion.itemId);
    }, [promotions]);

    useEffect(()=>{
        setChoosenGeneralPromotion(null);
        return () => {
            setChoosenGeneralPromotion(null);
        }
    },[])

    useEffect(()=>{
        if((choosenGeneralPromotion && !getCanApplyPromotion(choosenGeneralPromotion))){
            setChoosenGeneralPromotion(null);
        }
    },[choosenGeneralPromotion, selectedProducts])

    const getCanApplyPromotion = (promotion) => {
        let undiscountedAmount = 0;
        getDecoupledItems(selectedProducts).forEach((product) => {
            if(product?.promotion?.itemId) return false;
            undiscountedAmount += parseAmount(product.price) * product.quantity;
        });
        const promotionWithLimits = calculatePromotionLimits(promotion);
        console.log({ promotionWithLimits, undiscountedAmount });
        return doesPromotionApply(parseFloat(undiscountedAmount), 1, promotionWithLimits);
    };

    const getPromoDiscount = (promotion) => {
        if (promotion.promoDiscountType === "Porcentaje") {
            return `${promotion.discountValue}%`;
        }
        return formatCurrency(promotion.discountValue);
    };

    const getPromoSubtitle = (promotion) => {
        if (promotion.minPurchaseValue) {
            return `Para productos desde: ${formatCurrency(promotion.minPurchaseValue)}`;
        }
        return "";
    };
    if (availablePromotions.length === 0) {
        return null;
    }

    

    return (
        <FormControl sx={{ width: "100%", padding: 0, margin: 0 }}>
            <InputLabel id="demo-simple-select-disabled-label">Promoción</InputLabel>
            <Select
                labelId="demo-simple-select-disabled-label"
                id="demo-simple-select-disabled"
                value={choosenGeneralPromotion?.promoId ?? "-1"}
                label="Promoción"
                sx={{
                    "& .MuiSelect-select": {
                        padding: 1,
                    },
                }}
                onChange={(event) => {
                    const selectedPromotion = promotions.find((promo) => promo.promoId === event.target.value);
                    setChoosenGeneralPromotion(selectedPromotion);
                }}
            >
                <MenuItem value="-1">
                    <em>Ninguna promocion</em>
                </MenuItem>
                {availablePromotions.map((promotion) => (
                    <MenuItem
                        disabled={!getCanApplyPromotion(promotion)}
                        key={promotion.promoId}
                        value={promotion.promoId}
                    >
                        <StyledMenuItemContent>
                            <h6 className="title">{getPromotionName(promotion)}</h6>
                            <span className="subtitle">{getPromoSubtitle(promotion)}</span>
                            <span className="price">{getPromoDiscount(promotion)} OFF</span>
                        </StyledMenuItemContent>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
